'use client'
import { memo, type FC, type ReactNode, useMemo } from 'react'
import styled from 'styled-components'
import { mq, designGrid, getP25, rgbAlpha } from '@/styles'
import { useSession, useTranslator } from '@/hooks'
import { ButtonGoBack } from './ButtonGoBack'
import {  } from '@/hooks/'

type typePage = 'account' | 'invoices' | 'invoice' | 'client' | 'customers' | 'commissions' | 'dashboard' | 'invite_vet' | 'invite' | 'legal' | 'recommendations' | 'users' | 'user' | 'create-user' | 'vets' | 'vet' | 'my-vet' | 'my-vets' | 'my-customers' | 'orders' | 'vet_corporate_users' | 'vet_corporate_user'
interface Props {
  children?: ReactNode
  hasTabs?: boolean
  page?: typePage
  name?: string
}

const getTitle = (t, page, user, name) => {
  const title = t(`layout.header.${page}.title`)
  const titleDynamic = t(`layout.header.${page}.title_dynamic`)
  const goBack = t(`layout.header.${page}.go_back`)

  if (typeof title === 'string' && !titleDynamic) {
    return <h1>{goBack && <ButtonGoBack />}{title}</h1>
  } else {
    if(!user) return null
    switch(page) {
      case 'dashboard':
        return <h1>¡Hola {user.name}!</h1>
      case 'vet':
        return <h1>Datos de: {name}</h1>
      case 'recommendations':
        if (user.role === 'vet_partial_access' && user.name) return <h1>¡Hola {user.name}!</h1>
        return <h1>Tus Recomendaciones</h1>
      default:
        return null
    }
  }
}

export const Header:FC<Props> = memo(({ children, hasTabs = false, page, name = '' }) => {
  const { t } = useTranslator()
  const { user } = useSession()
  const H1 = useMemo(() => getTitle(t, page, user, name), [t, page, user, name])

  return (
    <HeaderStyled $hasTabs={hasTabs}>
      {H1}
      {children && children}
    </HeaderStyled>
  )
})

const HeaderStyled = styled.header<{ $hasTabs: boolean }>`
  ${designGrid({})}
  align-items: flex-start;
  background: var(--color-background_white);
  border-bottom: 1px solid ${rgbAlpha('--color-text', .1)};
  height: 60px;
  position: sticky;
  right: 0;
  top: 0;
  z-index: 10;

  ${mq.greaterThan('tablet')} {
    height: ${({ $hasTabs }) => $hasTabs ? 120 : 60}px;
  }

  h1 {
    ${getP25()}
    align-items: center;
    display: flex;
    grid-column: 2 / span 6;
    height: 60px;
    margin-left: 10px;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${mq.greaterThan('tablet')} {
      grid-column: 1 / span 7;
      margin-left: 0;
    }
  }

  ol {
    grid-column: ${({ $hasTabs }) => $hasTabs ? '1 / span 12' : '6 / span 7'};
    grid-row: ${({ $hasTabs }) => $hasTabs ? '2 / span 1' : '1 / span 1'};
    justify-content: ${({ $hasTabs }) => $hasTabs ? 'flex-start' : 'center'};
  }
`
